export const PARSE_CONFIG = {
    registrationState: "addressMap[RESIDENCE].region",
    registrationDistrict: 'addressMap[RESIDENCE].district',
    registrationCity: "addressMap[RESIDENCE].city",
    registrationStreet: "addressMap[RESIDENCE].street",
    registrationHouse: "addressMap[RESIDENCE].house",
    registrationApartment: "addressMap[RESIDENCE].flat",
    registrationHomePhone: "personalData.stationaryPhone",


    homeState: "addressMap[REGISTRATION].region",
    homeDistrict: "addressMap[REGISTRATION].district",
    homeCity: "addressMap[REGISTRATION].city",
    homeStreet: "addressMap[REGISTRATION].street",
    homeHouse: "addressMap[REGISTRATION].house",
    homeApartment: "addressMap[REGISTRATION].flat",
};
export const GET_PROFILE_CONFIG = {
    // registrationState: "addressMap.RESIDENCE.region",
    // registrationDistrict: "addressMap.RESIDENCE.district",
    // registrationCity: "addressMap.RESIDENCE.city",
    registrationStreet: "addressMap.RESIDENCE.street",
    registrationHouse: "addressMap.RESIDENCE.house",
    registrationApartment: "addressMap.RESIDENCE.flat",
    registrationHomePhone: "personalData.stationaryPhone",

    // homeState: "addressMap.REGISTRATION.region",
    // homeDistrict: "addressMap.REGISTRATION.district",
    // homeCity: "addressMap.REGISTRATION.city",
    homeStreet: "addressMap.REGISTRATION.street",
    homeHouse: "addressMap.REGISTRATION.house",
    homeApartment: "addressMap.REGISTRATION.flat",
};


export const BLOCKS_CONFIG = [
    {
        name: 'residenceRegion',
        fields: ['registrationState'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'residenceDistrict',
        fields: ['registrationDistrict'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'residenceCity',
        fields: ['registrationCity'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'residenceInfo',
        fields: ['registrationStreet','registrationHouse','registrationApartment','registrationHomePhone'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'homeRegion',
        fields: ['homeState'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'homeDistrict',
        fields: ['homeDistrict'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'homeCity',
        fields: ['homeCity'],
        confirmed: false,
        filledCount: 0
    },
    {
        name: 'homeInfo',
        fields: ['homeStreet','homeHouse','homeApartment'],
        confirmed: false,
        filledCount: 0
    }

];
